import { Quill } from "react-quill";
const Block = Quill.import("blots/block");
Block.tagName = "div";
export default Block;
